import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { SardineProvider } from '@sardine-ai/react-js-wrapper';
import PropTypes from 'prop-types';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Application from './Application';
import SessionTimeoutNotification from 'react/shared/components/misc/SessionTimeoutNotification';
import theme from 'react/shared/theme/Theme';

const eightHours = 8 * 60 * 60;

function CardSignupRoot(props) {
  return (
    <>
      <SessionTimeoutNotification
        redirectPath="/sign-in"
        timeoutInSeconds={props.userTimeoutInSeconds || eightHours}
      />
      <SardineProvider clientId={$tlf.sardine.clientId} environment={$tlf.sardine.env}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter basename="/signups/card/new">
              <Application showOnboardingBeacon={props.showOnboardingBeacon} />
            </BrowserRouter>
          </ThemeProvider>
        </StyledEngineProvider>
      </SardineProvider>
      <div id="flash" />
    </>
  );
}

export default CardSignupRoot;

CardSignupRoot.propTypes = {
  showOnboardingBeacon: PropTypes.bool,
  userTimeoutInSeconds: PropTypes.number,
};
